<template>
    <q-tabs color="faded" inverted position="top" align="justify" class="bg-white">
        <q-route-tab v-for="menu in menus" :key="menu.name" animated="false" slot="title" :to="menu.slug"
                     @click="checkAlerts(menu.slug)">
            <img class="icon-tab" :src="menu.icon">
            <span>{{ $T(menu.name) }}</span>
        </q-route-tab>
    </q-tabs>
</template>

<script>
    import {
        QTabs,
        QRouteTab,
        Cookies
    } from 'quasar-framework'
    import axios from "axios"

    export default {
        components: {
            QTabs,
            QRouteTab
        },

        computed: {
            /* menus() {
                return window.config.menus
            }, */

            devFolder() {
                return window.config.devAssetsFolder
            }
        },

        mounted() {
          this.getMenus()
        },

        data() {
          return {
            menus: [],
          }
        },

        methods: {
          checkAlerts(slug) {
            if (slug === '/alertas') {
              window.location.href = slug
            }
          },
          async getMenus() {
            this.menusFooter = []
            if (!Cookies.get('locale') || Cookies.get('locale') === undefined)
              Cookies.set('locale', 'pt', {expires: 1, path: '/'})
            this.portal_base = Cookies.get('portal')
            if (!this.portal_base) {
                axios.get(`${config.PortalBase}/get-portals`)
                    .then((response) => {
                      if (response.data.length > 0) {
                        this.portal_base = response.data[0].portal.id
                        Cookies.set('portal', this.portal_base, {expires: 1, path: '/'})
                      }
                    }).finally(async () => {
                        await this.getContentMenu()
                })
            } else {
              await this.getContentMenu()
            }
          },

          async getContentMenu() {
            this.redirect = '/' + this.$route.path.split('/').join('*')
            const {data} = await axios.get(`${config.appUrl}/${this.portal_base}/${null}/leagues?lang=${Cookies.get('locale')}`)
            this.menus.push({"name": "internacional", "slug": "/desporto/by/dsg", "icon": "/img/tab-icon-news.svg" })
            
            if (data['alert'])
                this.menus.push({"name": data['alert'].name, "slug": data['alert'].slug, "icon": data['alert'].image_path })

            this.menus.push(
                {"name": "angola", "slug": "/desporto/by/mml", "icon": "/img/tab-icon-local-news.svg" }
            )
            for (const item in data['leagues']) {
                this.menus.push(data['leagues'][item]);
            }
          }
        },
    }
</script>

<style lang="stylus" scoped>
    .icon-tab
        width 35px
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue